import React, { useState } from "react";
import { avatarGradient, initials } from "./taskUtils";

/** Round team-member avatar: photo when it loads, gradient initials otherwise. */
const MemberAvatar = ({ member, size = 40, className = "notes-modal__avatar" }) => {
  const [imgFailed, setImgFailed] = useState(false);
  if (member?.photoURL && !imgFailed) {
    return (
      <img
        className={className}
        src={member.photoURL}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setImgFailed(true)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span className={className} style={{ width: size, height: size, background: avatarGradient(member?.uid), fontSize: size * 0.38 }}>
      {initials(member?.name)}
    </span>
  );
};

export default MemberAvatar;
